import {useState} from 'react';

export const useDropdownOptions = ({onSelect, count, onClose, isOpen}) => {
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  const handleKeyDown = (e) => {
    if (!isOpen) {
      return;
    }

    switch (e.key) {
    case 'ArrowDown':
      e.preventDefault();
      setHighlightedIndex((prev) => (prev < count ? prev + 1 : 0));
      break;

    case 'ArrowUp':
      e.preventDefault();
      setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : count - 1));
      break;

    case 'Enter':
      e.preventDefault();
      if (highlightedIndex >= 0) {
        onSelect?.(highlightedIndex);
      }
      break;

    case 'Escape':
      onClose?.();
      break;
    default:
      break;
    }
  };

  return {handleKeyDown, highlightedIndex, setHighlightedIndex};
};
